export default {
  remote: 'api_marketplace_mfe',
  name: 'apiMarketplace',
  source: 'https://github.com/telus/api-marketplace-mfe',
  urlMapping: {
    localhost: 'https://assets.wcpreview.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1110683202/api-marketplace-mfe/v1/mf2/mf-manifest.json',
  },
};
